var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"home-content-layout"},[_c('Content',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }